import type { ThingTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const thingDark: ThingTheme = {
  name: 'Thing',
  common: commonDark,
  self
}

export default thingDark
